import { createFileRoute } from '@tanstack/react-router';

import { PublisherCreate } from '@/module/Publisher/PublisherCreate';

export const Route = createFileRoute('/_auth/publisher/_publisher/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <PublisherCreate />;
}
